import { render, staticRenderFns } from "./MessListErrorTable.vue?vue&type=template&id=0d06effe&scoped=true&"
import script from "./MessListErrorTable.vue?vue&type=script&lang=js&"
export * from "./MessListErrorTable.vue?vue&type=script&lang=js&"
import style0 from "./MessListErrorTable.vue?vue&type=style&index=0&id=0d06effe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06effe",
  null
  
)

export default component.exports